export const MAXIMUM_TEXT_LENGTH = 255;
